<template>
    <div>
        <DoughnutChart :data="chartData" width="389" height="260"/>
    </div>
</template>

<script>
import { ref } from 'vue'
import DoughnutChart from '../charts/DoughnutChart.vue'

// Import utilities
import { tailwindConfig } from '../utils/Utils'

export default {
    name: 'TopGeoAreas',
    components: {
        DoughnutChart,
    },
    props: {
        data: Array,
    },
    setup(props) {
        const chartData = ref({
            labels: props.data.map(item => item.area.name),
            datasets: [
                {
                    label: 'Geographic Area',
                    data: props.data.map(item => item.share),
                    backgroundColor: props.data.map(item => {
                        return tailwindConfig().theme.colors[item.tailwindColor.color][item.tailwindColor.grade]
                    }),
                },
            ],
        })

        return {
            chartData,
        }
    }
}
</script>
